define('models/CustomerLikeModel',['underscore','ObjectModel','LocalStorage','app'],function (_,ObjectModel,LocalStorage,app) {
    //
    // Model CartProduct
    //
    var CustomerLikeModelPrototype = {

        name:'CustomerLikeModel',
        idAttribute:'id_customer_like_product',
       // route:'apiCartProductModel',

        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },

    };

    var CustomerLikeModel = ObjectModel
    //.extend(LocalStorage)
        .extend(CustomerLikeModelPrototype);

    return CustomerLikeModel;
});
